import React, { Component } from "react";
import { Column, Row } from "simple-flexbox";
import DetailNameComponent from "../../components/detail/DetailNameComponent";
import { formValueSelector } from "redux-form"; // ES6

import { detailMember, editMember } from "../../actions/member/member_action";
import { withRouter } from "react-router-dom";
import FormContainer from "../../components/container/FormContainer";
import EditButtonComponent from "../../components/form/EditButtonComponent";
import {
  getMemberPending,
  getDetailMember,
  getMemberError,
} from "../../reducers/member/member_reducer";
import {
  getListBranch,
  getBranchPending,
} from "../../reducers/master-data/branch_reducer";
import { connect } from "react-redux";
import { reduxForm, Field } from "redux-form";
import {
  renderInput,
  renderSelect,
  renderInputSosmed,
  renderDate,
} from "../../components/form/FormComponent";
import { getCityList } from "../../reducers/master-data/city_reducer";
import { getUser } from "../../helpers/user";
import { StyleSheet, css } from "aphrodite";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faTwitter,
  faLinkedin,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";
import { listSubspesialis } from "../../actions/master-data/subspesialis_action";
import {
  getSubspesialisPending,
  getListSubspesialis,
  getSubspesialisError,
} from "../../reducers/master-data/subspesialis_reducer";
import ModalBranchVerification from "./Modal_branch_verification";
import DetailSubTitleComponent from "../../components/detail/DetailSubTitleComponent";
import {Col, Row as BootstrapRow} from "react-bootstrap";
import {getProvinceList} from "../../reducers/master-data/province_reducer";
import {listCity} from "../../actions/master-data/city_action";
import {provinceList} from "../../actions/master-data/province_action";
import {listBranch} from "../../actions/master-data/branch_action";

class MemberDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isEdit: false,
      isEditFile: false,
      modalBranchVerification: false,
      branchState: false,
      address_type: "",
      correspondence_section: "",
      correspondenceOptions: [
        { label: "Sesuai dengan Alamat Rumah", value: 1},
        { label: "Sesuai dengan Alamat RS Tempat Praktik", value: 2},
        { label: "Alamat Lain", value: 0}
      ]
    };
    this.shouldComponentRender = this.shouldComponentRender.bind(this);
    this.handleTriggerFormEdit = this.handleTriggerFormEdit.bind(this);
    this.handleTriggerEditFile = this.handleTriggerEditFile.bind(this);
    this.handleCancelEdit = this.handleCancelEdit.bind(this);
    this.handleBranchChange = this.handleBranchChange.bind(this);
    this.branchFix = this.branchFix.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    detailMember(getUser().id);
    this.props.provinceList({length: 10});
    this.props.listBranch({length: 10});
    this.props.listSubspesialis({length: 10});
  }

  componentDidUpdate(prevProps) {
    const {correspondence_type} = this.props;
    if(correspondence_type !== prevProps.correspondence_type) {
      this.setState({correspondence_section: correspondence_type});
    }
  }

  shouldComponentRender() {
    const { registrationList_pending } = this.props;
    if (registrationList_pending === false) {
      return false;
    }
    return true;
  }

  handleCancelEdit() {
    this.handleTriggerFormEdit();
    this.setState({ branchState: false });
  }

  handleTriggerFormEdit() {
    this.setState({ isEdit: !this.state.isEdit });
    this.setState({ isEditFile: false });
    this.props.reset();
  }

  handleCancelEdit() {
    this.handleTriggerFormEdit();
    this.setState({ branchState: false });
  }

  handleTriggerEditFile() {}

  handleSubmit(values) {
    this.setState({ branchState: true });
    const { detailMember_data, editMember, detailMember } = this.props;

    let correspondenceAddress = {};
    if(values?.correspondence_type.value === 0){
      correspondenceAddress = {
        correspondence_address:  values?.correspondence_address,
        correspondence_province:  values?.correspondence_province ? values?.correspondence_province?.value.toString() : "",
        correspondence_city:  values?.correspondence_city ? values?.correspondence_city?.value.toString() : "",
        correspondence_district: values?.correspondence_district,
        correspondence_village: values?.correspondence_village,
        correspondence_post_code: values?.correspondence_post_code,
      };
    }
    if (values?.correspondence_type?.value === 1){
      correspondenceAddress = {
        correspondence_address:  values.address,
        correspondence_province:  values.province ? values.province?.value.toString() : "",
        correspondence_city:  values.city ? values.city?.value.toString() : "",
        correspondence_district: values?.district,
        correspondence_village: values?.village,
        correspondence_post_code: values?.post_code,
      }
    }
    if (values?.correspondence_type?.value === 2){
      correspondenceAddress = {
        correspondence_address:  values.office_address,
        correspondence_province:  null,
        correspondence_city:  null,
        correspondence_district: null,
        correspondence_village: null,
        correspondence_post_code: null
      }
    }

    let param = {
      ...correspondenceAddress,
      title: values?.title,
      birthday: values?.birthday,
      identity_no: values?.identity_no,
      npwp: values?.npwp,
      npa_idi: values?.npa_idi,
      tribes: values?.tribes,
      primary_phone: values?.primary_phone,
      secondary_phone: values?.secondary_phone,
      primary_email: values?.primary_email,
      secondary_email: values?.secondary_email,
      home_address: values?.home_address,
      office_address: values?.office_address,
      office_phone: values?.office_phone,
      contact_emergency_name: values?.contact_emergency_name,
      contact_emergency_phone: values?.contact_emergency_phone,
      twitter: values?.twitter,
      linkedin: values?.linkedin,
      fb: values?.fb,
      instagram: values?.instagram,
      other_title: values?.other_title,
      other_front_title: values?.other_front_title,
      other_back_title: values?.other_back_title,
      post_code: values?.post_code,
      id: detailMember_data[0].id,
      place_of_birth: values.place_of_birth,
      identity_type: values.identity_type?.value,
      gender: values.gender?.value,
      religion: values.religion?.value,
      affiliation: values.affiliation,
      name: detailMember_data[0].name,
      subspecialist_id: values.subspecialist?.value,
      mailing_address: values.mailing_address?.value,
      address: values?.address,
      province:  values.province ? values.province?.value.toString() : "",
      city:  values.city ? values.city?.value.toString() : "",
      district: values?.district,
      village: values?.village,
      status: values?.status,
    };
    if (
        detailMember_data[0].branch_id === null ||
        detailMember_data[0].branch_id === undefined
    ) {
      param["branch"] = { value: values?.branch };
      param["branch_id"] = values?.branch?.value;
    }

    const callback = () => {
      detailMember(detailMember_data[0].id);
      this.handleTriggerFormEdit();
    };

    editMember(param, callback);
  }

  handleBranchChange() {
    this.setState({
      modalBranchVerification: true,
    });
  }

  branchFix = (data) => {
    this.setState({ branchState: data });
  };

  render() {
    const {
      listCity,
      listCity_data,
      listProvince_data,
      editMember_pending,
      handleSubmit,
      listBranch_data,
      listSubspesialis_data,
      formValue,
      initialValues,
      correspondence_type,
      change
    } = this.props;
    const {
      isEdit,
      address_type,
      correspondence_section,
      correspondenceOptions } = this.state;

    const empty_correspondence_section = correspondence_section === null || correspondence_section === undefined;
    const show_correspondence = empty_correspondence_section ? correspondence_type : correspondence_section;

    let cityOptions = [],
        provinceOptions = [],
        correspondenceCityOptions = [],
        branchOptions = [],
        subspecialistOptions = [];

    let genderOptions = [
      { label: "Laki-Laki", value: 1 },
      { label: "Perempuan", value: 0 },
    ];
    let identityOptions = [
      { label: "KTP", value: "KTP" },
      { label: "SIM", value: "SIM" },
      { label: "Passport", value: "Passport" },
    ];
    let religionOptions = [
      { label: "Islam", value: "Islam" },
      { label: "Kristen Protestan", value: "Kristen Protestan" },
      { label: "Katolik", value: "Katolik" },
      { label: "Hindu", value: "Hindu" },
      { label: "Buddha", value: "Buddha" },
      { label: "Kong Hu Cu", value: "Kong Hu Cu" },
    ];
    let addressOptions = [
      { label: "Alamat Rumah", value: 1 },
      { label: "Alamat RS Tempat Praktik", value: 2 },
    ];

    const handleCityChange = (state, type) => {
      listCity({length: !state ? 0 : 10, province_id: state?.value || ""});
      this.setState({ address_type: type });
    }

    const handleCorrespondenceAddressChange = (state) => {
      this.setState({ correspondence_section: state?.value === null ? "" : state?.value });
      change("correspondence_address", null)
      change("correspondence_province", null)
      change("correspondence_city", null)
      change("correspondence_district", null)
      change("correspondence_village", null)
      change("correspondence_post_code", null)
    }

    if(address_type === 'personal' && listCity_data && listCity_data.data.length !== 0){
      cityOptions = listCity_data.data.map((item) => ({
        label: item.name,
        value: item.city_id,
      }));
    }
    if(address_type === 'correspondence' && listCity_data && listCity_data.data.length !== 0){
      correspondenceCityOptions = listCity_data.data.map((item) => ({
        label: item.name,
        value: item.city_id,
      }));
    }

    if (listProvince_data && listProvince_data.length !== 0) {
      provinceOptions = listProvince_data.map((item) => ({
        label: item.name,
        value: item.province_id,
      }));
    }

    if (listBranch_data && listBranch_data.length !== 0) {
      branchOptions = listBranch_data.data.map(({ name, id }) => ({
        label: name,
        value: id,
      }));
    }

    if (listSubspesialis_data && listSubspesialis_data.length !== 0) {
      subspecialistOptions = listSubspesialis_data.data.map(({ name, id }) => ({
        label: name,
        value: id,
      }));
    }

    let currentYear = new Date().getFullYear();
    let yearOptions = [];
    for (let i = currentYear; i >= 1900; i--) {
      yearOptions = [...yearOptions, { label: i, value: i }];
    }

    let secondary_email, secondary_phone, branch;
    if (formValue) {
      ({ secondary_email, secondary_phone, branch } = formValue);
    }

    return (
        <form
            onSubmit={handleSubmit(this.handleSubmit)}
            style={{ width: "100%" }}
        >
          <ModalBranchVerification
              show={this.state.modalBranchVerification}
              onHide={() =>
                  this.setState({
                    modalBranchVerification: false,
                  })
              }
              onBranchChange={this.branchFix}
          />
          <Row
              vertical="center"
              horizontal="space-between"
              style={{ width: "100%", marginBottom: 20 }}
          >
            <DetailNameComponent name="Profile" />
            <EditButtonComponent
                isEdit={isEdit}
                triggerIsEdit={this.handleTriggerFormEdit}
                isLoading={editMember_pending}
            />
          </Row>
          <DetailSubTitleComponent title="Data Pribadi"/>
          <BootstrapRow lg={isEdit ? 2 : 1}>
            <Col md={12}>
              <FormContainer label="Nama">
                <Field
                    isDetail={!isEdit}
                    name="name"
                    placeholder="Masukkan Nama"
                    disabled
                    component={renderInput}
                />
              </FormContainer>
              <FormContainer label="Gelar Depan">
                <Field
                    isDetail={!isEdit}
                    name="other_front_title"
                    placeholder="Masukkan Gelar Depan"
                    component={renderInput}
                />
              </FormContainer>
              <FormContainer label="Gelar Belakang">
                <Field
                    isDetail={!isEdit}
                    options={subspecialistOptions}
                    name="other_back_title"
                    placeholder="Masukkan Gelar Belakang"
                    component={renderInput}
                />
              </FormContainer>
              <FormContainer label="Subspesialis">
                <Field
                    isDetail={!isEdit}
                    options={subspecialistOptions}
                    name="subspecialist"
                    isAsync
                    asyncUrl="master_data/subspecialist/find"
                    placeholder="Pilih subspesialis"
                    component={renderSelect}
                />
              </FormContainer>
              <FormContainer mandatory label="NPA IDI">
                <Field
                    isDetail={!isEdit}
                    name="npa_idi"
                    placeholder="Masukkan NPA IDI"
                    component={renderInput}
                />
              </FormContainer>
              <FormContainer mandatory label="Cabang">
                <Field
                    isDisabled={!!branch}
                    isDetail={!isEdit}
                    isAsync
                    asyncUrl="master_data/branch/find"
                    options={branchOptions}
                    name="branch"
                    placeholder="Pilih cabang"
                    component={renderSelect}
                />
              </FormContainer>
              <FormContainer mandatory label="Tempat Lahir">
                <Field
                    isDetail={!isEdit}
                    name="place_of_birth"
                    placeholder="Masukkan Kota"
                    component={renderInput}
                />
              </FormContainer>
              <FormContainer mandatory label="Tanggal Lahir">
                <Field
                    isDetail={!isEdit}
                    name="birthday"
                    component={renderDate}
                />
              </FormContainer>
              <FormContainer mandatory label="Jenis Identitas">
                <Field
                    isDetail={!isEdit}
                    options={identityOptions}
                    name="identity_type"
                    placeholder="Pilih Jenis Identitas"
                    component={renderSelect}
                />
              </FormContainer>
              <FormContainer mandatory label="No Identitas">
                <Field
                    isDetail={!isEdit}
                    type="text"
                    name="identity_no"
                    placeholder="Masukkan nomor identitas"
                    component={renderInput}
                />
              </FormContainer>
            </Col>
            <Col md={12}>
              <FormContainer label="No NPWP">
                <Field
                    isDetail={!isEdit}
                    type="number"
                    name="npwp"
                    placeholder="Masukkan nomor npwp"
                    component={renderInput}
                />
              </FormContainer>
              <FormContainer label="Suku Bangsa">
                <Field
                    isDetail={!isEdit}
                    name="tribes"
                    placeholder="Masukkan suku bangsa"
                    component={renderInput}
                />
              </FormContainer>
              <FormContainer mandatory label="Jenis Kelamin">
                <Field
                    isDetail={!isEdit}
                    options={genderOptions}
                    name="gender"
                    placeholder="Pilih jenis kelamin"
                    component={renderSelect}
                />
              </FormContainer>
              <FormContainer label="Agama">
                <Field
                    isDetail={!isEdit}
                    options={religionOptions}
                    name="religion"
                    placeholder="Pilih Agama"
                    component={renderSelect}
                />
              </FormContainer>
              <FormContainer label="Anggota Organisasi">
                <Field
                    isDetail={!isEdit}
                    name="affiliation"
                    placeholder="Masukkan keanggotaan"
                    component={renderInput}
                />
              </FormContainer>
              <FormContainer mandatory label="No Telepon">
                <Field
                    isDetail={!isEdit}
                    type="number"
                    name="primary_phone"
                    placeholder="Masukkan telepon utama"
                    component={renderInput}
                />
              </FormContainer>
              <FormContainer label="No. Telepon Alternatif">
                <Field
                    isDetail={!isEdit}
                    type="number"
                    name="secondary_phone"
                    placeholder="Masukkan telepon alternatif"
                    component={renderInput}
                />
              </FormContainer>
              <FormContainer mandatory label="Email">
                <Field
                    isDetail={!isEdit}
                    type="email"
                    name="primary_email"
                    placeholder="Masukkan email utama"
                    component={renderInput}
                />
              </FormContainer>
              <FormContainer label="Email Alternatif">
                <Field
                    type="email"
                    isDetail={!isEdit}
                    name="secondary_email"
                    placeholder="Masukkan email alternatif"
                    component={renderInput}
                />
              </FormContainer>
            </Col>
          </BootstrapRow>

          {/*Divider*/}
          <DetailSubTitleComponent title="Alamat Rumah"/>
          <BootstrapRow lg={isEdit ? 2 : 1}>
            <Col md={12}>
              <FormContainer mandatory label="Jalan">
                <Field
                    isDetail={!isEdit}
                    name="address"
                    placeholder="Masukkan jalan"
                    component={renderInput}
                />
              </FormContainer>
              <FormContainer mandatory label="Provinsi">
                <Field
                    isDetail={!isEdit}
                    options={provinceOptions}
                    name="province"
                    type="province"
                    isAsync
                    asyncUrl="master_data/data_reference/find_province"
                    placeholder="Pilih provinsi"
                    onChange={(state) => {
                      if(!state){
                        change("city", null);
                        handleCityChange(null);
                      }else{
                        handleCityChange(state, "personal")
                      }
                    }}
                    component={renderSelect}
                />
              </FormContainer>
              <FormContainer mandatory label="Kabupaten">
                <Field
                    isDetail={!isEdit}
                    options={cityOptions}
                    onFocus={() => {
                      cityOptions.length < 1 &&
                      handleCityChange(initialValues?.province, "personal")
                    }}
                    name="city"
                    type="city"
                    isAsync
                    asyncUrl="master_data/data_reference/find_city"
                    placeholder="Pilih Kabupaten"
                    component={renderSelect}
                />
              </FormContainer>
            </Col>
            <Col md={12}>
              <FormContainer mandatory label="Kecamatan">
                <Field
                    isDetail={!isEdit}
                    options={addressOptions}
                    name="district"
                    placeholder="Pilih kecamatan"
                    component={renderInput}
                />
              </FormContainer>
              <FormContainer mandatory label="Kelurahan">
                <Field
                    isDetail={!isEdit}
                    options={addressOptions}
                    name="village"
                    placeholder="Pilih kelurahan"
                    component={renderInput}
                />
              </FormContainer>
              <FormContainer mandatory label="Kode Pos">
                <Field
                    isDetail={!isEdit}
                    name="post_code"
                    placeholder="Masukkan kode pos"
                    component={renderInput}
                />
              </FormContainer>
            </Col>
          </BootstrapRow>

          {/*Divider*/}
          <DetailSubTitleComponent title="Tempat Praktik"/>
          <FormContainer label="Alamat RS Tempat Praktik">
            <Field
                isDetail={!isEdit}
                name="office_address"
                placeholder="Masukkan alamat rs praktik"
                component={renderInput}
            />
          </FormContainer>

          {/*Divider*/}
          <DetailSubTitleComponent title="Korespondensi"/>
          <FormContainer mandatory label="Alamat Korespondensi">
            <Field
                isDetail={!isEdit}
                name="correspondence_type"
                placeholder="Masukkan alamat korespondensi"
                options={correspondenceOptions}
                onChange={handleCorrespondenceAddressChange}
                component={renderSelect}
            />
          </FormContainer>
          {show_correspondence === 0 && <BootstrapRow lg={isEdit ? 2 : 1}>
            <Col md={12}>
              <FormContainer mandatory label="Jalan">
                <Field
                    isDetail={!isEdit}
                    name="correspondence_address"
                    placeholder="Masukkan jalan"
                    component={renderInput}
                />
              </FormContainer>
              <FormContainer mandatory label="Provinsi">
                <Field
                    isDetail={!isEdit}
                    options={provinceOptions}
                    name="correspondence_province"
                    type="province"
                    isAsync
                    asyncUrl="master_data/data_reference/find_province"
                    placeholder="Pilih provinsi"
                    onChange={(state) => {
                      if(!state){
                        change("correspondence_city", null);
                        handleCityChange(null);
                      }else{
                        handleCityChange(state, "correspondence")
                      }
                    }}
                    component={renderSelect}
                />
              </FormContainer>
              <FormContainer mandatory label="Kabupaten">
                <Field
                    isDetail={!isEdit}
                    options={correspondenceCityOptions}
                    name="correspondence_city"
                    type="city"
                    isAsync
                    asyncUrl="master_data/data_reference/find_city"
                    placeholder="Pilih Kabupaten"
                    onFocus={() => {
                      correspondenceCityOptions.length < 1 &&
                      handleCityChange(
                          initialValues?.correspondence_province,
                          "correspondence"
                      )
                    }}
                    component={renderSelect}
                />
              </FormContainer>
            </Col>
            <Col md={12}>
              <FormContainer mandatory label="Kecamatan">
                <Field
                    isDetail={!isEdit}
                    name="correspondence_district"
                    placeholder="Pilih kecamatan"
                    component={renderInput}
                />
              </FormContainer>
              <FormContainer mandatory label="Kelurahan">
                <Field
                    isDetail={!isEdit}
                    name="correspondence_village"
                    placeholder="Pilih kelurahan"
                    component={renderInput}
                />
              </FormContainer>
              <FormContainer mandatory label="Kode Pos">
                <Field
                    isDetail={!isEdit}
                    name="correspondence_post_code"
                    placeholder="Masukkan kode pos"
                    component={renderInput}
                />
              </FormContainer>
            </Col>
          </BootstrapRow>}

          {/*Divider*/}
          <DetailSubTitleComponent title="Kontak Lain"/>
          <FormContainer label="Telepon Kantor">
            <Field
                isDetail={!isEdit}
                type="number"
                name="office_phone"
                placeholder="Masukkan telepon kantor"
                component={renderInput}
            />
          </FormContainer>
          <FormContainer label="Nama Kontak Darurat">
            <Field
                isDetail={!isEdit}
                name="contact_emergency_name"
                placeholder="Masukkan nama"
                component={renderInput}
            />
          </FormContainer>
          <FormContainer label="Telp. Kontak Darurat">
            <Field
                isDetail={!isEdit}
                type="number"
                name="contact_emergency_phone"
                placeholder="Masukkan nomor darurat"
                component={renderInput}
            />
          </FormContainer>
          <DetailSubTitleComponent title="Sosial Media"/>
          <FormContainer label="Username">
            <Row
                style={{ width: "100%" }}
                horizontal={isEdit ? "space-between" : ""}
                wrap
            >
              <Column style={{ width: isEdit ? "48%" : "60px" }}>
                <Field
                    isDetail={!isEdit}
                    name="twitter"
                    placeholder="Username twitter"
                    component={renderInputSosmed}
                    startIcon={(props) => (
                        <div className={css(styles.icon)}>
                          <FontAwesomeIcon
                              icon={faTwitter}
                              size="lg"
                              color="#495057"
                              {...props}
                          />
                        </div>
                    )}
                />
              </Column>
              <Column style={{ width: isEdit ? "48%" : "60px" }}>
                <Field
                    isDetail={!isEdit}
                    name="fb"
                    placeholder="Username facebook"
                    component={renderInputSosmed}
                    startIcon={(props) => (
                        <div className={css(styles.icon)}>
                          <FontAwesomeIcon
                              icon={faFacebook}
                              size="lg"
                              color="#495057"
                              {...props}
                          />
                        </div>
                    )}
                />
              </Column>
              <Column style={{ width: isEdit ? "48%" : "60px" }}>
                <Field
                    isDetail={!isEdit}
                    name="linkedin"
                    placeholder="Username linkedin"
                    component={renderInputSosmed}
                    startIcon={(props) => (
                        <div className={css(styles.icon)}>
                          <FontAwesomeIcon
                              icon={faLinkedin}
                              size="lg"
                              color="#495057"
                              {...props}
                          />
                        </div>
                    )}
                />
              </Column>
              <Column style={{ width: isEdit ? "48%" : "60px" }}>
                <Field
                    isDetail={!isEdit}
                    name="instagram"
                    placeholder="Username instagram"
                    component={renderInputSosmed}
                    startIcon={(props) => (
                        <div className={css(styles.icon)}>
                          <FontAwesomeIcon
                              icon={faInstagram}
                              color="#495057"
                              size="lg"
                              {...props}
                          />
                        </div>
                    )}
                    // startIcon={EditIcon}
                />
              </Column>
            </Row>
          </FormContainer>
        </form>
    );
  }
}

const styles = StyleSheet.create({
  dot: {
    height: 8,
    width: 8,
    borderRadius: 4,
    backgroundColor: "black",
    margin: "0px 10px",
  },
  icon: {
    position: "absolute",
    top: 0,
    height: 20,
    color: "#495057",
    width: 20,
    // left: 10,
  },
});

function validate(values) {
  const {
    npa_idi,
    branch,
    place_of_birth,
    birthday,
    identity_type,
    identity_no,
    gender,
    primary_phone,
    primary_email,
    address,
    province,
    city,
    district,
    village,
    post_code,
    correspondence_type,
    correspondence_address,
    correspondence_province,
    correspondence_city,
    correspondence_district,
    correspondence_village,
    correspondence_post_code,
  } = values;
  const errors = {};
  if (!npa_idi) {
    errors.npa_idi = "NPA IDI wajib diisi";
  }
  if (!branch) {
    errors.branch = "Cabang wajib diisi";
  }
  if (!place_of_birth) {
    errors.place_of_birth = "Tempat Lahir wajib diisi";
  }
  if (!birthday) {
    errors.birthday = "Tanggal Lahir wajib diisi";
  }
  if (!identity_type) {
    errors.identity_type = "Jenis Identitas wajib diisi";
  }
  if (!identity_no) {
    errors.identity_no = "No Identitas wajib diisi";
  }
  if (!gender) {
    errors.gender = "Jenis kelamin wajib diisi";
  }
  if (!primary_phone) {
    errors.primary_phone = "No telepon wajib diisi";
  }
  if (!primary_email) {
    errors.primary_email = "email wajib diisi";
  }
  if (!address) {
    errors.address = "Jalan wajib diisi";
  }
  if (!province) {
    errors.province = "Provinsi wajib diisi";
  }
  if (!city && !province) {
    errors.city = "Pilih provinsi terlebih dahulu";
  }
  if (!city && province) {
    errors.city = "Kabupaten/Kota wajib diisi";
  }
  if (!district) {
    errors.district = "Kecamatan wajib diisi";
  }
  if (!village) {
    errors.village = "Kelurahan wajib diisi";
  }
  if (!post_code) {
    errors.post_code = "Kode Pos wajib diisi";
  }
  if(!correspondence_type){
    errors.correspondence_type = "Alamat korespondensi wajib diisi";
  }
  if(correspondence_type?.value === 0){
    if (!correspondence_address) {
      errors.correspondence_address = "Jalan wajib diisi";
    }
    if (!correspondence_province) {
      errors.correspondence_province = "Provinsi wajib diisi";
    }
    if (!correspondence_city && !correspondence_province) {
      errors.correspondence_city = "Pilih provinsi terlebih dahulu";
    }
    if (!correspondence_city && correspondence_province) {
      errors.correspondence_city = "Kabupaten/Kota wajib diisi";
    }
    if (!correspondence_district) {
      errors.correspondence_district = "Kecamatan wajib diisi";
    }
    if (!correspondence_village) {
      errors.correspondence_village = "Kelurahan wajib diisi";
    }
    if (!correspondence_post_code) {
      errors.correspondence_post_code = "Kode Pos wajib diisi";
    }
  }

  return errors;
}

MemberDetail = reduxForm({
  // a unique name for the form
  form: "MemberDataDiri",
  validate: validate,
  // keepDirtyOnReinitialize: true,
  shouldError: () => true,
  enableReinitialize: true,
})(MemberDetail);

function mapStateToProps(state) {

  const { detailMember, editMember, listCity, listBranch, listSubspesialis, provinceList } = state;
  let initialValues = {};
  const detailMember_data = getDetailMember(detailMember);
  let place_of_birth,
      identity_type,
      gender,
      branch_data,
      religion,
      email,
      mailing_address,
      name,
      other_back_title,
      other_front_title,
      correspondence_type,
      province,
      city,
      correspondence_province,
      correspondence_city,
      member_profile;
  if (detailMember_data && detailMember_data.length !== 0) {
    [
      {
        name,
        other_back_title,
        other_front_title,
        email,
        member_profile,
        member_profile: {
          correspondence_type,
          province,
          city,
          correspondence_province,
          correspondence_city,
          place_of_birth,
          identity_type,
          gender,
          religion,
          mailing_address,
          gender,
        },
        branch_data,
      },
    ] = detailMember_data;

    initialValues = {
      ...member_profile,
      other_back_title: other_back_title || "-",
      other_front_title: other_front_title || "-",
      name: name,
      primary_email: email,
      mailing_address: {
        label:
            mailing_address === 1 ? "Alamat Rumah" : "Alamat RS Tempat Praktik",
        value: mailing_address,
      },
      subspecialist: {
        label: member_profile.subspecialist_data
            ? member_profile.subspecialist_data.name
            : null,
        value: member_profile.subspecialist_data
            ? member_profile.subspecialist_data.id
            : null,
      }
    };
  }
  
  if (branch_data) {
    initialValues.branch = {
      label: branch_data?.name,
      value: branch_data.id,
    };
  }
  if (identity_type) {
    initialValues.identity_type = {
      label: identity_type,
      value: identity_type,
    };
  }
  if (gender !== null) {
    initialValues.gender = {
      label: gender === 0 ? "Perempuan" : "Laki-laki",
      value: gender,
    };
  }
  if (religion) {
    initialValues.religion = { label: religion, value: religion };
  }

  if (province) {
    initialValues.province = {
      label: member_profile?.province_data?.name,
      value: member_profile?.province_data?.province_id,
    }
  }
  if (city) {
    initialValues.city = {
      label: member_profile?.city_data?.name,
      value: member_profile?.city_data?.city_id,
    };
  }
  if (correspondence_province) {
    initialValues.correspondence_province = {
      label: member_profile?.correspondence_province_data?.name,
      value: member_profile?.correspondence_province_data?.province_id,
    }
  }
  if (correspondence_city) {
    initialValues.correspondence_city = {
      label: member_profile?.correspondence_city_data?.name,
      value: member_profile?.correspondence_city_data?.city_id,
    };
  }
  if (correspondence_type === 0) {
    initialValues.correspondence_type = {
      label: "Alamat lain",
      value: correspondence_type,
    }
  }else if(correspondence_type === 1) {
    initialValues.correspondence_type = {
      label: "Sesuai dengan Alamat Rumah",
      value: correspondence_type,
    }
  }else if(correspondence_type === 2) {
    initialValues.correspondence_type = {
      label: "Sesuai dengan Alamat RS Tempat Praktik",
      value: correspondence_type,
    }
  }else{
    initialValues.correspondence_type = correspondence_type
  }

  const selector = formValueSelector("MemberDataDiri");
  const formValue = selector(
      state,
      "secondary_email",
      "secondary_phone",
      "branch"
  );

  return {
    detailMember_data: getDetailMember(detailMember),
    detailMember_error: getMemberError(detailMember),
    detailMember_pending: getMemberPending(detailMember),
    editMember_error: getMemberError(editMember),
    editMember_pending: getMemberPending(editMember),
    listCity_data: getCityList(listCity),
    listProvince_data: getProvinceList(provinceList),
    listBranch_data: getListBranch(listBranch),
    listBranch_pending: getBranchPending(listBranch),
    listSubspesialis_data: getListSubspesialis(listSubspesialis),
    listSubspesialis_error: getSubspesialisError(listSubspesialis),
    listSubspesialis_pending: getSubspesialisPending(listSubspesialis),
    initialValues,
    formValue,
    correspondence_type,
  };
}


export default connect(mapStateToProps, {
  detailMember,
  editMember,
  listBranch,
  listSubspesialis,
  listCity,
  provinceList
})(withRouter(MemberDetail));
